<template>
  <Modal>
    <Modal.Title>Default privacy controls</Modal.Title>
    <Modal.Body>
      <DefaultFilePrivacyBody v-model="isPrivate" :is-basic="isBasic" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="isBasic"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import type { User } from '@/shared/graphql/legacy/generated'
import DefaultFilePrivacyBody from './DefaultFilePrivacyBody.vue'
import { useDefaultFilePrivacy } from './useDefaultFilePrivacy'

const { close } = useModal()

const props = defineProps<{
  user: User
}>()

const { isPrivate, isBasic, loading, save } = useDefaultFilePrivacy(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
